import React, { FC } from "react"
import InformationModal from "components/views/modal/InformationModal"
import L10n from "lib/carrot-l10n"
import { Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { useSelector } from "react-redux"
import { getHasCostShare } from "../../../../derivedSelectors"
import { getDeductibleStatus } from "../../../../reducers/userInfo"
import { DeductibleStatus } from "carrot-api/types/DeductibleStatus"
import { H2Library } from "@carrotfertility/carotene"
import { CSDTable } from "./CSDTable"
import { ExternalDeductibleInformational } from "./ExternalDeductibleInformational"
import { YourCostShareInformational } from "./YourCostShareInformational"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export type HowMuchReimbursedModalProps = {
  onExit: () => void
}

const HowMuchReimbursedModal: FC<HowMuchReimbursedModalProps> = ({ onExit }) => {
  const costShare = useSelector(getHasCostShare)
  const deductibleStatus: DeductibleStatus = useSelector(getDeductibleStatus)

  return (
    <InformationModal onExit={onExit} titleText={l`How Much Will I Be Reimbursed?`}>
      <div className="ph45 mw-600">
        <H2Library>{l`How much will I be reimbursed?`}</H2Library>
        <Spacer height={2.0} />
        <Body color="black-80">
          {l`Individual reimbursements are subject to bank fees, taxes, and other plan details like deductibles and cost sharing. Here’s what applies to you:`}
        </Body>
        {deductibleStatus === DeductibleStatus.CarrotSpecificDeductible && <CSDTable />}
        {deductibleStatus === DeductibleStatus.ExternalDeductible && <ExternalDeductibleInformational />}
        {costShare && <YourCostShareInformational />}
        <Spacer height={3.0} />
      </div>
    </InformationModal>
  )
}

export { HowMuchReimbursedModal }
